import { debounce, screenCategory } from '../library';
import ToggleableComponent from "./ToggleableComponent";

const NAV_MARGIN_TRIGGER = 60;

export default class MainNavigation {

  constructor() {
    this.element = document.querySelector("#block-mainnavigation .mainnavigation-menu > .menu");

    this._onScrollNav = this._onScrollNav.bind(this);
    this._debounceScrollNavHandler = debounce(this._onScrollNav, 100);
    this._prevButtonHandler = this._prevButtonHandler.bind(this);
    this._nextButtonHandler = this._nextButtonHandler.bind(this);
    this._scrollMouseDownHandler = this._scrollMouseDownHandler.bind(this)
    this._scrollMouseMoveHandler = this._scrollMouseMoveHandler.bind(this)
    this._scrollMouseUpHandler = this._scrollMouseUpHandler.bind(this)

    if (!!this.element) {
      this.setup();
    }
  }

  setup() {
    // keep track current Screen to know
    this._currentScreen = screenCategory();

    document.addEventListener('resize', debounce(() => {
      this._currentScreen = screenCategory();
    }, 500));

    this.setupClickableMenu();

    this.setUpScrollMenu();
  }

  _closeMenu(item) {
    item.classList.remove('hover');

    const children = item.querySelectorAll('li.hover');

    Array.from(children).forEach((child) => {
      child.classList.remove('hover');
    })
  }

  _openMenu(item, parentUL) {
    // Hide other open menus
    for (let j = 0; j < parentUL.children.length; j++) {
      if(parentUL.children[j] != item) {
        this._closeMenu(parentUL.children[j]);
      }
    }

    const isHover = item.classList.contains('hover');

    const outsideClickListener = (event) => {
      if (!this.element.contains(event.target)) {
        this._closeMenu(item);
        removeOutsideClickListener();
      }
    }

    const removeOutsideClickListener = () => {
      document.removeEventListener('click', outsideClickListener)
    }

    // Trigger hover class
    if (isHover) {
      this._closeMenu(item);
      removeOutsideClickListener();
    } else {
      item.classList.add('hover');
      document.addEventListener('click', outsideClickListener)
    }
  };

  setupClickableMenu() {
    const links = this.element.querySelectorAll('.menu-item--expanded > a');

    // // Exit when blurring menu
    // element.addEventListener('pointerleave', (e) => {
    //   console.log("BLUURRRR");
    //   if(element.classList.contains('hover-open')) {
    //     element.classList.remove('hover-open');
    //     for (let i = 0; i < LINKS.length; i++ ) {
    //       LINKS[i].parentElement.classList.remove('hover');
    //     }
    //   }
    // });

    Array.from(links).forEach(link => {
      const item = link.parentElement;

      const shouldRegisterHoverMenu = (e) => this._currentScreen !== 'mobile';

      link.addEventListener('click', (e) => {
        if (shouldRegisterHoverMenu()) {
          e.preventDefault();
          this._openMenu(item, item.parentElement);
        }
      })
    })
  }

  _onScrollNav() {
    this.menuPosition = this.element.scrollLeft;

    const menuInvisibleSize = this.menuSize - this.containerWidth;
    const menuEndOffset = menuInvisibleSize - NAV_MARGIN_TRIGGER;

    if (this.menuPosition < NAV_MARGIN_TRIGGER) {
      this.prevButton.classList.add('hidden');
      this.nextButton.classList.remove('hidden');
    }
    else if (this.menuPosition < menuEndOffset) {
      this.prevButton.classList.remove('hidden');
      this.nextButton.classList.remove('hidden');
    } else if (this.menuPosition >= menuEndOffset) {
      this.prevButton.classList.remove('hidden');
      this.nextButton.classList.add('hidden');
    }
  }

  _nextButtonHandler(e) {
    e.preventDefault();

    // this.element.scrollLeft += this.scrollWidth;
    const n = this.element.children.length;
    const nextSlide = (this.currentSlide + 1 + n) % n;

    this.element.children[nextSlide].scrollIntoView({inline: 'start', block: 'center', behavior: 'smooth'});
    this.currentSlide = nextSlide;
  }

  _prevButtonHandler(e) {
    e.preventDefault();

    const n = this.element.children.length;
    const prevSlide = (this.currentSlide - 1 + n) % n;

    this.element.children[prevSlide].scrollIntoView({inline: 'start', block: 'center', behavior: 'smooth'});
    this.currentSlide = prevSlide;
  }

  _initScrollbar() {
    this.containerWidth = window.innerWidth;

    if (this._currentScreen === 'mobile') {
      this._clearScrollbar();
      console.log('Screen size is mobile, disable scroll');
      return;
    }

    this.menuSize = this.element.scrollWidth;

    if (this.menuSize <= this.containerWidth) {
      this._clearScrollbar();

      console.log('All items displayed in viewport');
      return;
    }

    this.element.scrollLeft = 0;
    this.currentSlide = 0;

    this.element.addEventListener('scroll', this._debounceScrollNavHandler);
    this.nextButton.addEventListener('click', this._nextButtonHandler);
    this.prevButton.addEventListener('click', this._prevButtonHandler);

    this.element.addEventListener('mousedown', this._scrollMouseDownHandler);
    this.element.classList.add('init-scroll');

    this._onScrollNav();
  }

  _clearScrollbar() {
    this.nextButton.classList.add('hidden');
    this.prevButton.classList.add('hidden');
    this.nextButton.removeEventListener('click', this._nextButtonHandler);
    this.prevButton.removeEventListener('click', this._prevButtonHandler);

    this.element.removeEventListener('scroll', this._debounceScrollNavHandler);

    this.element.removeEventListener('mousedown', this._scrollMouseDownHandler);
    this.element.classList.remove('init-scroll');
  }

  setUpScrollMenu() {
    this.prevButton =  document.querySelector('#block-mainnavigation .prev-button');
    this.nextButton =  document.querySelector('#block-mainnavigation .next-button');

    this._initScrollbar();

    window.addEventListener('resize', debounce(() => {
      this._initScrollbar();
    }, 200));

    const navLabel = document.getElementById("block-mainnavigation-menu")

    new ToggleableComponent(
      navLabel,
      navLabel,
      () => {}
    )
  }

  _scrollMouseDownHandler(e) {
    this._lastPostion = {
      x: e.clientX,
      left: this.element.scrollLeft,
    }

    this.element.style.cssText = 'cursor: grabbing; user-select: none;';

    // Note: use document to ensure it works on outside
    document.addEventListener('mousemove', this._scrollMouseMoveHandler);
    document.addEventListener('mouseup', this._scrollMouseUpHandler)
  }

  _scrollMouseMoveHandler(e) {
    const dx = e.clientX - this._lastPostion.x;

    this.element.scrollLeft = this._lastPostion.left - dx;
  }

  _scrollMouseUpHandler(e) {

    this.element.style.cssText = '';

    document.removeEventListener('mousemove', this._scrollMouseMoveHandler);
    document.removeEventListener('mouseup', this._scrollMouseUpHandler);
  }
}
